module.exports = __webpack_public_path__ + "static/media/step7.6ffc27df.svg";